import { Space } from 'antd';
import Profile from './Profile';
import Notification from './Notification';

export default function HeaderContent() {
  return (
    <div className="flex items-center w-full gap-2">
      {/* <Search /> */}
      <div className="flex-1" />
      <Space size={8}>
        {/* <Notification /> */}
        <Profile />
      </Space>
    </div>
  );
}
